import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { GlobalsService } from '../../services/globals.service';
import { InventoryService } from 'app/services/inventory.service';
import { CustomerService } from 'app/services/customer.service';
import { OrdersService } from 'app/services/orders.service';
import { CarrierTrackingService } from 'app/services/carrier-tracking.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { Chart, registerables } from 'chart.js/auto';
import { isArray } from 'chart.js/helpers';
import { animate, style, transition, trigger } from '@angular/animations';
import * as XLSX from 'xlsx';
import { buildDashboardThemeVars } from '../dashboard-widget-theme';
import { UsersService } from 'app/services/users.service';
import { OmsService } from 'app/services/oms.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Blob } from 'buffer';
import { PageEvent } from '@angular/material/paginator';

interface OrderPeriodStats {
	orders: number;
	units: number;
}

@Component({
	selector: 'app-sticker-feed-control',
	templateUrl: './sticker-feed-control.component.html',
	styleUrls: ['./sticker-feed-control.component.scss'],
	animations: [
		trigger('fade', [
			transition(':enter', [style({ opacity: 0 }), animate('200ms 150ms ease-in', style({ opacity: 1 }))]),
			transition(':leave', [animate('150ms ease-out', style({ opacity: 0 }))]),
		]),
	]
})
export class StickerFeedControlComponent implements OnInit, OnDestroy {

	clients: any[] = [];
	loading = true;
	saving: { [key: string]: boolean } = {};
	saved: { [key: string]: boolean } = {};
	saveError: { [key: string]: string } = {};
	newBrand: { [key: string]: string } = {};
	brands: any = false;
	stockidUploadError: { [key: string]: string } = {};

	debtorSearchTerm: { [key: string]: string } = {};
	debtorSearchResults: { [key: string]: any[] } = {};
	debtorSearching: { [key: string]: boolean } = {};
	branchOptions: { [key: string]: any[] } = {};
	debtorSearchSub: any = null;

	shipviaOptions: any[] = [];

	labels_used: any = [];
	label_in_use: Boolean = false;
	
	keys_used: any = [];
	key_in_use: Boolean = false;

	analytics_icon: SafeHtml;
	orders_icon: SafeHtml;
	settings_icon: SafeHtml;
	viewing_icon: SafeHtml;

	copying: any = false;

	logs: { [key: string]: any[] } = {};
	logsLoading: { [key: string]: boolean } = {};
	logsError: { [key: string]: string } = {};
	logsPage: { [key: string]: number } = {};
	logsTotal: { [key: string]: number } = {};
	logsDateFrom: { [key: string]: string } = {};
	logsDateTo: { [key: string]: string } = {};
	readonly logsPageSize = 25;

	openOrders: { [key: string]: any[] } = {};
	openOrdersLoading: { [key: string]: boolean } = {};
	openOrdersPageIndex: { [key: string]: number } = {};
	openOrdersPageSize: { [key: string]: number } = {};

	openPurchaseOrders: { [key: string]: any[] } = {};
	openPurchaseOrdersLoading: { [key: string]: boolean } = {};

	orderCounts: { [key: string]: { ytd: OrderPeriodStats; mtd: OrderPeriodStats; week: OrderPeriodStats; custom?: OrderPeriodStats } } = {};
	orderCountsLoading: { [key: string]: boolean } = {};
	orderPeriod: { [key: string]: 'week' | 'mtd' | 'custom' } = {};
	customDateFrom: { [key: string]: string } = {};
	customDateTo: { [key: string]: string } = {};

	historicalOrders: { [key: string]: any[] } = {};
	historicalOrdersLoading: { [key: string]: boolean } = {};
	historicalOrdersTotal: { [key: string]: number } = {};
	historicalOrdersTotalUnits: { [key: string]: number } = {};
	historicalOrdersPageIndex: { [key: string]: number } = {};
	historicalOrdersPageSize: { [key: string]: number } = {};
	selectedHistoricalOrder: { [vendorKey: string]: any } = {};

	// ordersSearchTerm holds the not-yet-committed text currently typed into the search box;
	// hitting Enter commits it into searchChips as a removable chip. searchChips is shared
	// between the Open and Historical tabs — each chip matches order #, cust ref #, tracking #,
	// document #, or stockid, and multiple chips AND together (each narrows further). Open
	// filters client-side (already fully loaded); Historical re-queries the server since it's
	// paginated/capped.
	ordersSearchTerm: { [key: string]: string } = {};
	searchChips: { [key: string]: string[] } = {};

	activityTrend: { [key: string]: { dates: string[]; logs: number[]; orders: number[] } } = {};
	activityTrendLoading: { [key: string]: boolean } = {};
	@ViewChildren('activityChartRef') activityChartRefs!: QueryList<ElementRef<HTMLCanvasElement>>;
	private activityCharts: { [key: string]: Chart } = {};

	// day drilldown from clicking a point on the activity trend chart — chartDateFilter
	// drives Open/Historical filtering (AND-combined with searchChips), chartPopover
	// is just the display state for the small info box anchored to the clicked point.
	chartDateFilter: { [key: string]: string } = {};
	chartPopover: { [key: string]: { date: string; orders: number; logs: number; orderNumbers: string[]; x: number; y: number } | null } = {};

	orderLinesCache: { [orderno: string]: any[] } = {};
	selectedOrder: { [vendorKey: string]: any } = {};
	orderLinesLoading: { [orderno: string]: boolean } = {};

	orderTotals: { [orderno: string]: { subtotal: number; taxtotal: number; freighttotal: number; total: number } } = {};
	orderTotalsLoading: { [orderno: string]: boolean } = {};
	type_label: any = false;
	user: any = false;
	pickinglink: any;
	config: any = false;
	invoicelink: any = false;

	constructor(private globalsService: GlobalsService, private modalService: NgbModal, private omsService: OmsService, private usersService: UsersService, private globals: GlobalsService, private inventoryService: InventoryService, private customerService: CustomerService, private ordersService: OrdersService, private sanitizer: DomSanitizer, private globalSearchService: GlobalSearchService, private router: Router, private carrierTracking: CarrierTrackingService) {
		this.analytics_icon = this.sanitizer.bypassSecurityTrustHtml('<rect x="10" y="34" width="10" height="20" rx="2" fill="gray"/> <rect x="27" y="22" width="10" height="32" rx="2" fill="gray"/> <rect x="44" y="10" width="10" height="44" rx="2" fill="gray"/> <path d="M10 28 L27 16 L37 20 L54 6" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0.6"/>');
		this.viewing_icon = this.sanitizer.bypassSecurityTrustHtml( '<path d="M4 32 Q32 8 60 32 Q32 56 4 32 Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>' + '<circle cx="32" cy="32" r="10" fill="currentColor"/>' );
		this.orders_icon = this.sanitizer.bypassSecurityTrustHtml( '<rect x="14" y="10" width="30" height="44" rx="4" fill="none" stroke="currentColor" stroke-width="4"/>' + '<line x1="20" y1="24" x2="38" y2="24" stroke="currentColor" stroke-width="3" opacity="0.6"/>' + '<line x1="20" y1="34" x2="38" y2="34" stroke="currentColor" stroke-width="3" opacity="0.6"/>' + '<line x1="20" y1="44" x2="32" y2="44" stroke="currentColor" stroke-width="3" opacity="0.6"/>' + '<circle cx="46" cy="14" r="11" fill="currentColor"/>' + '<text x="46" y="19" font-size="14" font-weight="bold" fill="white" text-anchor="middle" font-family="sans-serif">#</text>' );
		this.settings_icon = this.sanitizer.bypassSecurityTrustHtml( '<line x1="10" y1="16" x2="54" y2="16" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="24" cy="16" r="6" fill="currentColor"/>' + '<line x1="10" y1="32" x2="54" y2="32" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="40" cy="32" r="6" fill="currentColor"/>' + '<line x1="10" y1="48" x2="54" y2="48" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="20" cy="48" r="6" fill="currentColor"/>');
	}

	ngOnInit(): void {
		this.load();
		this.globalSearchService.shipvia.subscribe((results: any) => {
			this.shipviaOptions = Array.isArray(results) ? results : [];
		});
		this.globalSearchService.userData.subscribe(r => {
			this.user = r.user;
		});
		this.config = this.globalSearchService.getConfig();
		this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink
		this.invoicelink = this.config.apiServer.baseUrl + this.config.apiServer.pickingInvoice;

		this.ordersService.getCancelReasons().subscribe((r: any) => {
			this.cancelReasons = (r && r.success && Array.isArray(r.data) && r.data.length) ? r.data : this.defaultCancelReasons;
		}, () => {
			this.cancelReasons = this.defaultCancelReasons;
		});
	}

	all_loaded:Boolean = false;
	loaded(){
		console.log(`loading...`);
		if(this.clients.length && !this.all_loaded ){
			let loading = false;
			this.clients.forEach((client)=>{
				if(client.id !== 'new'){
					const key = client.vendor_key;
					if (this.logsLoading[key] !== undefined  && this.logsLoading[key]) { loading = true }
					if (this.openOrdersLoading[key] !== undefined  && this.openOrdersLoading[key]) { loading = true }
					if (this.openPurchaseOrdersLoading[key] !== undefined  && this.openPurchaseOrdersLoading[key]) { loading = true }
					if (this.orderCountsLoading[key] !== undefined  && this.orderCountsLoading[key]) { loading = true }
				}
			})
			if(loading == false){
				this.all_loaded = true;
			}else{
				setTimeout(()=>{
					this.loaded()
				}, 1500)
			}
		}
	}


	ngOnDestroy(): void {
		Object.keys(this.activityCharts).forEach((key) => this.destroyActivityChart(key));
	}

	// card close fade duration (ms) - must match the .is-closing opacity transition in the scss
	private readonly CARD_CLOSE_DURATION = 250;

	flipClientCard(client, type){
		//type = settings (form for editing vendors - uses save to update information)|| analytics is the client-scoped connection log
		// the footer icons that call this are only shown while the card is not focused, so this always opens
		client.closing = false;
		client.viewing = type;
		client.focused = true;
		this.type_label = type;
		if (type === 'analytics') {
			this.loadLogs(client);
		}

		if (type === 'orders') {
			this.selectedOrder[client.vendor_key] = null;
			this.selectedHistoricalOrder[client.vendor_key] = null;
			this.loadOpenOrders(client);
			this.loadOpenPurchaseOrders(client);
			this.loadOrderCounts(client);
			this.loadActivityTrend(client);
			this.loadHistoricalOrders(client, 0);
		}
	}

	loadLogs(vendor: any, page: number = 1) {
		const key = vendor.vendor_key;
		this.logsLoading[key] = true;
		this.logsError[key] = '';
		this.logsPage[key] = page;

		this.globals.getFeedConnectionLogs(vendor.id, {
			page,
			page_size: this.logsPageSize,
			date_from: this.logsDateFrom[key] || '',
			date_to: this.logsDateTo[key] || ''
		}).subscribe((result: any) => {
			this.logsLoading[key] = false;
			if (!result || result.success === false) {
				this.logsError[key] = (result && result.error) || 'Failed to load logs';
				return;
			}
			this.logs[key] = result.logs || [];
			this.logsTotal[key] = result.total || 0;
		}, (err) => {
			this.logsLoading[key] = false;
			this.logsError[key] = 'Failed to load logs (' + (err?.status || 'network error') + ')';
		});
	}

	searchLogs(vendor: any) {
		this.loadLogs(vendor, 1);
	}

	logsTotalPages(vendor: any): number {
		return Math.max(1, Math.ceil((this.logsTotal[vendor.vendor_key] || 0) / this.logsPageSize));
	}

	logsPrevPage(vendor: any) {
		const key = vendor.vendor_key;
		if ((this.logsPage[key] || 1) > 1) {
			this.loadLogs(vendor, (this.logsPage[key] || 1) - 1);
		}
	}

	logsNextPage(vendor: any) {
		const key = vendor.vendor_key;
		if ((this.logsPage[key] || 1) < this.logsTotalPages(vendor)) {
			this.loadLogs(vendor, (this.logsPage[key] || 1) + 1);
		}
	}

	formatLogTimestamp(dt: string): string {
		if (!dt) { return ''; }
		const [datePart, timePart] = dt.split(' ');
		if (!timePart) { return dt; }
		const [year, month, day] = datePart.split('-');
		let [hour, minute, second] = timePart.split(':');
		let hourNum = parseInt(hour, 10);
		const am = hourNum >= 12 ? 'pm' : 'am';
		hourNum = hourNum % 12 > 0 ? hourNum % 12 : 12;
		return `${month}/${day}/${year} ${hourNum}:${minute}:${second}${am}`;
	}

	closeExpanded(){
		const focusedClient = this.clients.find((c) => c.focused);
		if (focusedClient) {
			this.collapseClient(focusedClient);
		}
	}

	private collapseClient(client){
		client.closing = true;
		this.destroyActivityChart(client.vendor_key);
		setTimeout(() => {
			client.focused = false;
			client.closing = false;
			client.viewing = '';
			this.selectedOrder[client.vendor_key] = null;
			this.ordersSearchTerm[client.vendor_key] = '';
			this.searchChips[client.vendor_key] = [];
			this.chartDateFilter[client.vendor_key] = null;
			this.chartPopover[client.vendor_key] = null;
		}, this.CARD_CLOSE_DURATION);
	}

	get anyExpanded(): boolean {
		return this.clients.some((c) => c.focused);
	}

	load() {
		this.globals.getFeedExclusions().subscribe((result: any) => {
			this.clients = result.vendors || [];
			this.keys_used = result.vendor_keys;
			this.labels_used = result.vendor_labels;
			this.formatvendors();
			this.loaded();
		});

		this.inventoryService.getBrands().subscribe((res: any)=>{
			this.brands = res;
		})
	}

	clientsformatted: Boolean = false;
	formatvendors(){
		this.clients.forEach((v: any)=>{
			v.excluded_brands = isArray(v.excluded_brands) ? v.excluded_brands : [];
			v.excluded_stockids = isArray(v.excluded_stockids) ? v.excluded_stockids : [];

			const shipvia = isArray(v.shipvia) ? v.shipvia : [];
			v.allowed_shipvia = shipvia.map((s: any) => s.shipper_id);
			v.shipvia_freight = {};
			v.shipvia_requires_label = {};
			shipvia.forEach((s: any) => {
				v.shipvia_freight[s.shipper_id] = s.freight_price || '';
				v.shipvia_requires_label[s.shipper_id] = !!s.requires_label;
			});

			v.api_endpoints = isArray(v.api_endpoints) ? v.api_endpoints : [];
			v.allowed_endpoints = isArray(v.api_endpoints_allowed) ? v.api_endpoints_allowed : [];

			v.showItemPicker = false;
			v.showBrandEditor = false;
			v.brandFilter = '';
			v.password = '';
			v.viewing = '';

			if(v.lastsent != '' && v.lastsent){
				const [datePart, timePart] = v.lastsent.split(' ');
				const [year, month, day] = datePart.split('-');
				let [hour, minute] = timePart.split(':');
				let am = 'am'
				if(hour > 12){
					am = 'pm'
					hour = hour % 12 > 0 ? hour % 12 : 12;
				}
				v.lastsent = `${month}/${day} ${hour}:${minute}${am}`;
			}else{
				v.lastsent = 'never';
			}
			

			v.protocol = v.protocol || '';
			v.protocol_type = v.protocol_type || '';
			v.port = v.port || '';
			v.filename = v.filename || '';
			v.emailcopy = !!(+v.emailcopy);
			v.blankstartrow = !!(+v.blankstartrow);

			v.connection_type = v.connection_type || 'ftp';
			v.auth_type = v.auth_type || 'oauth2_client_credentials';
			v.client_id = v.client_id || '';
			v.revealed = null;
			v.generatingCredentials = false;

			v.debtorno = v.debtorno || '';
			v.branchcode = v.branchcode || '';
			v.debtor_name = v.debtor_name || '';
			v.branch_name = v.branch_name || '';
			this.debtorSearchTerm[v.vendor_key] = v.debtorno ? this.displayDebtorFn({ debtorno: v.debtorno, name: v.debtor_name }) : '';

			v.focused = false;
			v.closing = false;

			v.status = this.computeStatus(v);

			if (v.debtorno) {
				this.loadBranches(v);
				this.loadOpenOrders(v);
				this.loadOrderCounts(v);
				this.loadOpenPurchaseOrders(v);
			}
		})
		
	}

	overall_counts: any = [];
	total_order_count:any = 0;
	total_unit_count: any = 0;
	getOverallTotals(orders, key){
		if(!this.overall_counts[key]){
			this.overall_counts[key] = [];
		}
		this.overall_counts[key]['orders'] = orders.length;
		if(orders.length){
			this.overall_counts[key]['orderdata'] = orders;
			this.overall_counts[key]['linedata'] = [];
			let count = 0;
			orders.forEach((ord) => {
				this.overall_counts[key]['linedata'] = [...this.overall_counts[key]['linedata'], ...ord.lines]; 
				count += ord.lines.reduce((acc: number, line) => {
					return Number(acc) + Number(line.ordered);
				  }, 0);
			});
			this.overall_counts[key]['units'] = count;
		}else{
			this.overall_counts[key]['units'] = 0;
		}
		this.total_order_count = Object.values(this.overall_counts).reduce((acc: number, client) => {
			return Number(acc) + Number(client['orders']);
		}, 0);
		this.total_unit_count = Object.values(this.overall_counts).reduce((acc: number, client) => {
			return Number(acc) + Number(client['units']);
		}, 0);
	}



	loadOrderCounts(vendor: any) {
		if (!vendor.debtorno) { return; }
		const key = vendor.vendor_key;
		if (!this.orderPeriod[key]) { this.orderPeriod[key] = 'mtd'; }
		this.orderCountsLoading[key] = true;
		const toStats = (period: any): OrderPeriodStats => ({
			orders: (period && period.orders) || 0,
			units: (period && period.units) || 0
		});
		const dateFrom = this.orderPeriod[key] === 'custom' ? (this.customDateFrom[key] || '') : '';
		const dateTo = this.orderPeriod[key] === 'custom' ? (this.customDateTo[key] || '') : '';
		this.ordersService.getOrderCounts(vendor.debtorno, dateFrom, dateTo, vendor.branchcode, vendor.connection_type).subscribe((result: any) => {
			this.orderCountsLoading[key] = false;
			this.orderCounts[key] = {
				ytd: toStats(result && result.ytd),
				mtd: toStats(result && result.mtd),
				week: toStats(result && result.week),
				custom: result && result.custom ? toStats(result.custom) : undefined
			};
		}, () => {
			this.orderCountsLoading[key] = false;
			this.orderCounts[key] = { ytd: toStats(null), mtd: toStats(null), week: toStats(null) };
		});
	}

	setOrderPeriod(vendor: any, period: 'week' | 'mtd' | 'custom') {
		this.chartDateFilter[vendor.vendor_key] = null;
		this.chartPopover[vendor.vendor_key] = null;
		this.orderPeriod[vendor.vendor_key] = period;
		if (period === 'custom') {
			// wait for the user to pick a range and hit Apply before reloading anything
			return;
		}
		this.loadOrderCounts(vendor);
		this.loadActivityTrend(vendor);
		this.loadHistoricalOrders(vendor, 0);
	}

	applyCustomRange(vendor: any) {
		const key = vendor.vendor_key;
		const from = this.customDateFrom[key];
		const to = this.customDateTo[key];
		if (!from || !to || from > to) { return; }
		this.chartDateFilter[key] = null;
		this.chartPopover[key] = null;
		this.orderPeriod[key] = 'custom';
		this.loadOrderCounts(vendor);
		this.loadActivityTrend(vendor);
		this.loadHistoricalOrders(vendor, 0);
	}

	totalOrdersForPeriod(vendor: any): number {
		const counts = this.orderCounts[vendor.vendor_key];
		const period = this.orderPeriod[vendor.vendor_key] || 'mtd';
		return (counts && counts[period]) ? counts[period].orders : 0;
	}

	unitsForPeriod(vendor: any): number {
		const counts = this.orderCounts[vendor.vendor_key];
		const period = this.orderPeriod[vendor.vendor_key] || 'mtd';
		return (counts && counts[period]) ? counts[period].units : 0;
	}

	// toolbar report totals: the Open tab isn't period-scoped (it's just "what's open right
	// now"), while Historical is scoped to the selected period — so each tab reports against
	// its own data instead of both sharing the period-wide totalOrdersForPeriod/unitsForPeriod.
	reportOrdersCount(vendor: any): number {
		if (this.historicalView) {
			return this.historicalOrdersTotal[vendor.vendor_key] || 0;
		}
		return this.filteredOpenOrdersCount(vendor);
	}

	reportUnitsCount(vendor: any): number {
		const key = vendor.vendor_key;
		if (this.historicalView) {
			return this.historicalOrdersTotalUnits[key] || 0;
		}
		if ((this.searchChips[key] || []).length || this.chartDateFilter[key]) {
			return this.filteredOpenOrdersUnits(vendor);
		}
		return (this.overall_counts[key] && this.overall_counts[key]['units']) || 0;
	}

	loadActivityTrend(vendor: any) {
		if (!vendor.debtorno) { return; }
		const key = vendor.vendor_key;
		const period = this.orderPeriod[key] || 'mtd';
		this.activityTrendLoading[key] = true;
		const dateFrom = period === 'custom' ? (this.customDateFrom[key] || '') : '';
		const dateTo = period === 'custom' ? (this.customDateTo[key] || '') : '';
		this.globals.getActivityTrend(vendor.id, vendor.debtorno, period, dateFrom, dateTo).subscribe((result: any) => {
			this.activityTrendLoading[key] = false;
			this.activityTrend[key] = {
				dates: (result && result.dates) || [],
				logs: (result && result.logs) || [],
				orders: (result && result.orders) || []
			};
			setTimeout(() => this.renderActivityChart(vendor));
		}, () => {
			this.activityTrendLoading[key] = false;
			this.activityTrend[key] = { dates: [], logs: [], orders: [] };
		});
	}

	private renderActivityChart(vendor: any) {
		const key = vendor.vendor_key;
		const trend = this.activityTrend[key];
		if (!trend) { return; }

		const canvasRef = this.activityChartRefs?.find((ref) => ref.nativeElement.dataset.key === key);
		const canvas = canvasRef?.nativeElement;
		if (!canvas) { return; }
		const ctx = canvas.getContext('2d');
		if (!ctx) { return; }

		this.destroyActivityChart(key);

		this.activityCharts[key] = new Chart(ctx, {
			type: 'line',
			data: {
				labels: trend.dates,
				datasets: [
					{
						label: 'Orders Placed',
						data: trend.orders,
						borderColor: 'rgba(54, 162, 235, 1)',
						backgroundColor: 'rgba(54, 162, 235, 0.15)',
						borderWidth: 2,
						pointRadius: 2,
						tension: 0.3,
						fill: true
					},
					{
						label: 'Log Activity',
						data: trend.logs,
						borderColor: 'rgba(255, 159, 64, 1)',
						backgroundColor: 'rgba(255, 159, 64, 0.15)',
						borderWidth: 2,
						pointRadius: 2,
						tension: 0.3,
						fill: true
					}
				]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				interaction: { mode: 'index', intersect: false },
				scales: {
					y: { beginAtZero: true, ticks: { precision: 0 } },
					x: { grid: { display: false } }
				},
				plugins: {
					legend: { display: true, position: 'top' },
					tooltip: { mode: 'index', intersect: false }
				},
				onClick: (evt, elements) => this.onChartPointClick(vendor, elements)
			}
		});
	}

	private onChartPointClick(vendor: any, elements: any[]) {
		if (!elements.length) { return; }
		const key = vendor.vendor_key;
		const trend = this.activityTrend[key];
		const idx = elements[0].index;
		const date = trend?.dates[idx];
		if (!date) { return; }

		// clicking the already-open point again toggles the drilldown off
		if (this.chartPopover[key]?.date === date) {
			this.chartPopover[key] = null;
			this.chartDateFilter[key] = null;
			this.reapplyDateFilter(vendor);
			return;
		}

		const orderNumbers = (this.openOrders[key] || [])
			.filter((o: any) => (o.orddate || o.date_created || '').slice(0, 10) === date)
			.map((o: any) => o.orderno);

		const pt = elements[0].element; // canvas-local pixel coords, matches the position:relative wrap
		const clamped = this.clampPopoverPosition(key, pt.x, pt.y);
		this.chartPopover[key] = {
			date,
			orders: trend.orders[idx] || 0,
			logs: trend.logs[idx] || 0,
			orderNumbers,
			x: clamped.x,
			y: clamped.y
		};
		this.chartDateFilter[key] = date;
		this.reapplyDateFilter(vendor);
	}

	// keeps the popover fully inside the chart wrap even when the clicked point is near an
	// edge — uses the popover's CSS max-width/an estimated max height (rather than measuring
	// the actual rendered box) to keep this a pure, synchronous calculation.
	private clampPopoverPosition(key: string, rawX: number, rawY: number): { x: number; y: number } {
		const POPOVER_HALF_WIDTH = 120; // half of .chart-point-popover's max-width (240px)
		const POPOVER_MAX_HEIGHT = 140; // generous estimate of the popover's rendered height
		const EDGE_MARGIN = 4;

		const canvasRef = this.activityChartRefs?.find((ref) => ref.nativeElement.dataset.key === key);
		const wrapWidth = canvasRef?.nativeElement.clientWidth || 0;

		let x = rawX;
		if (wrapWidth > 0) {
			const minX = POPOVER_HALF_WIDTH + EDGE_MARGIN;
			const maxX = wrapWidth - POPOVER_HALF_WIDTH - EDGE_MARGIN;
			x = maxX >= minX ? Math.min(Math.max(rawX, minX), maxX) : wrapWidth / 2;
		}

		// the popover renders above the point (translateY(-100%)); keep enough headroom so it
		// doesn't get clipped off the top of the wrap when the point is near the top.
		const y = Math.max(rawY, POPOVER_MAX_HEIGHT + EDGE_MARGIN);

		return { x, y };
	}

	private reapplyDateFilter(vendor: any) {
		const key = vendor.vendor_key;
		this.openOrdersPageIndex[key] = 0;
		this.clearOrderSelection(vendor);
		if (this.historicalView) {
			this.loadHistoricalOrders(vendor, 0);
		}
		// Open view needs no explicit reload: filteredOpenOrders() reads chartDateFilter live.
	}

	// a filter change can drop the currently-open order detail panel out of the visible list —
	// close it rather than leaving a stale/mismatched selection showing.
	private clearOrderSelection(vendor: any) {
		const key = vendor.vendor_key;
		this.selectedOrder[key] = null;
		this.selectedHistoricalOrder[key] = null;
	}

	clearChartDateFilter(vendor: any) {
		const key = vendor.vendor_key;
		this.chartDateFilter[key] = null;
		this.chartPopover[key] = null;
		this.reapplyDateFilter(vendor);
	}

	graph_visible: Boolean = false;
	showgraph(){
		this.graph_visible = !this.graph_visible;
		if (!this.graph_visible) {
			Object.keys(this.chartPopover).forEach((k) => this.chartPopover[k] = null);
		}
	}

	private destroyActivityChart(key: string) {
		this.chartPopover[key] = null;
		if (this.activityCharts[key]) {
			this.activityCharts[key].destroy();
			delete this.activityCharts[key];
		}
	}

	historicalView: Boolean = false;
	toggleHistorical(){
		this.historicalView = !this.historicalView;
	}

	orderfiles: any = [];
	uploadingShippingLabel = false;

	// manually-supplied shipping label upload (e.g. a carrier emails a label instead of the
	// sticker feed generating one). Naming is forced server-side to the same
	// {index}-{orderno}-{debtorno}-label convention stickerfeedapi.php's uploadtocdn() uses,
	// so these line up with feed-generated labels for lookup/cleanup.
	onSelectShippingLabel(event: any, order: any) {
		if (!order || !order.orderno || !order.debtorno) { return; }

		const file = event.addedFiles[0];
		if (!file) { return; }

		this.uploadingShippingLabel = true;
		this.readFileAsDataUrl(file).then(content => {
			const upload = {
				content,
				name: file.name,
				mime: file.type,
				debtorno: order.debtorno,
				orderno: order.orderno,
			};

			this.ordersService.uploadOrderShippingLabel(upload).subscribe((results: any) => {
				this.orderfiles = Array.isArray(results) ? results : [];
				this.uploadingShippingLabel = false;
			}, () => {
				this.uploadingShippingLabel = false;
			});
		}, () => {
			this.uploadingShippingLabel = false;
		});
	}

	removeShippingLabel(file: any, order: any) {
		if (!order || !file || !file.link) { return; }
		if(confirm(`remove uploaded document ${file.name}`)){
			this.ordersService.removeOrderFile({ debtorno: order.debtorno, orderno: order.orderno, link: file.link }).subscribe((results: any) => {
				this.orderfiles = Array.isArray(results) ? results : [];
			});
		}
	}

	// same predefined reason codes as open-orders' cancel flow (order_cancellations.reason
	// joins against cancel_reasons.code), with the same client-side fallback if that lookup fails
	private defaultCancelReasons = [
		{ id: '1', label: 'Customer Request', code: 'CUSTOMER_REQUEST', requires_notes: '0', sort_order: '1', is_active: '1' },
		{ id: '2', label: 'Out of Stock', code: 'OUT_OF_STOCK', requires_notes: '0', sort_order: '2', is_active: '1' },
		{ id: '3', label: 'Duplicate Order', code: 'DUPLICATE_ORDER', requires_notes: '0', sort_order: '3', is_active: '1' },
		{ id: '4', label: 'Other', code: 'Other', requires_notes: '1', sort_order: '4', is_active: '1' },
	];
	cancelReasons: any[] = [];

	@ViewChild('confirmCancelSticker') confirmCancelStickerRef: ElementRef;
	cancellingOrder: any = null;
	cancellingVendor: any = null;
	cancellingStickerOrderNo: any = null;
	selectedCancelReason: any = null;
	cancelNotesText: string = '';
	cancelStickerError: string = '';

	get cancelStickerReasonRequiresNotes(): boolean {
		return this.selectedCancelReason?.requires_notes === '1';
	}

	selectCancelReason(reason: any) {
		this.selectedCancelReason = reason;
		this.cancelStickerError = '';
	}

	cancelOrder(order: any, vendor: any) {
		this.cancellingOrder = order;
		this.cancellingVendor = vendor;
		this.selectedCancelReason = null;
		this.cancelNotesText = '';
		this.cancelStickerError = '';
		this.modalService.open(this.confirmCancelStickerRef, { ariaLabelledBy: 'modal-title' }).result.then(() => {}, () => {
			this.cancellingOrder = null;
			this.cancellingVendor = null;
		});
	}

	confirmCancelOrder(modal: any) {
		if (!this.selectedCancelReason || (this.cancelStickerReasonRequiresNotes && !this.cancelNotesText.trim())) {
			this.cancelStickerError = 'A cancellation reason is required.';
			return;
		}

		const order = this.cancellingOrder;
		const vendor = this.cancellingVendor;
		if (!order) { return; }

		const data = {
			orderno: order.orderno,
			debtorno: order.debtorno,
			reason: this.selectedCancelReason.code,
			notes: this.cancelNotesText.trim()
		};

		this.cancellingStickerOrderNo = order.orderno;
		this.globals.cancelStickerOrder(data).subscribe((res: any) => {
			this.cancellingStickerOrderNo = null;
			if (!res || res.success === false) {
				this.cancelStickerError = (res && res.error) || 'Failed to cancel order';
				return;
			}
			modal.close();
			this.cancellingOrder = null;
			this.globalSearchService.showNotification(`Order #${order.orderno} cancelled.`, 'info', 'bottom', 'right');
			if (vendor) {
				this.selectedOrder[vendor.vendor_key] = null;
				this.loadOpenOrders(vendor);
			}
			this.cancellingVendor = null;
		}, (err) => {
			this.cancellingStickerOrderNo = null;
			this.cancelStickerError = 'Failed to cancel order (' + (err?.status || 'network error') + ')';
		});
	}

	private readFileAsDataUrl(file: File): Promise<string> {
		return new Promise<string>((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = e => resolve((e.target as FileReader).result as string);
			reader.onerror = () => reject(null);
			reader.readAsDataURL(file);
		});
	}

	loadOpenOrders(vendor: any) {
		if (!vendor.debtorno) { return; }
		const key = vendor.vendor_key;
		this.openOrdersLoading[key] = true;

		this.ordersService.getCustomerOpenStickerOrders(vendor.debtorno, vendor.branchcode, vendor.connection_type).subscribe((results: any) => {
			this.openOrdersLoading[key] = false;
			const list = Array.isArray(results) ? results : [];
			this.openOrders[key] = [...list].sort((a, b) => this.parseOrderDate(a?.date_created) - this.parseOrderDate(b?.date_created));
			this.openOrdersPageIndex[key] = 0;

			if(this.openOrders[key][0]){
				this.selectOrder(this.openOrders[key][0], key);
			}
			this.getOverallTotals(this.openOrders[key], key);
		}, () => {
			this.openOrdersLoading[key] = false;
			this.openOrders[key] = [];
		});
	}

	// unfiltered — used by the collapsed-card summary badge, so a leftover search term
	// from a prior focused session never makes that badge look wrong.
	openOrdersCount(vendor: any): number {
		return (this.openOrders[vendor.vendor_key] || []).length;
	}

	private matchesOrdersSearch(value: any, term: string): boolean {
		return value != null && String(value).toLowerCase().includes(term);
	}

	// open orders are already fully loaded client-side, so search just filters that array —
	// each chip matches order #, cust ref #, tracking #, document #, or any line's stock ID,
	// and chips AND together (every chip must match). AND-combined with chartDateFilter (set
	// by clicking a point on the activity trend chart), matched against orddate to line up
	// with how the chart buckets its "Orders Placed" series.
	filteredOpenOrders(vendor: any): any[] {
		const key = vendor.vendor_key;
		const all = this.openOrders[key] || [];
		const chips = (this.searchChips[key] || []).map((t) => t.toLowerCase());
		const dateFilter = this.chartDateFilter[key];
		if (!chips.length && !dateFilter) { return all; }
		return all.filter((o: any) =>
			(!dateFilter || (o.orddate || o.date_created || '').slice(0, 10) === dateFilter) &&
			chips.every((term) =>
				this.matchesOrdersSearch(o.orderno, term) ||
				this.matchesOrdersSearch(o.ponumber, term) ||
				this.matchesOrdersSearch(o.transno, term) ||
				this.matchesOrdersSearch(o.tracking_display, term) ||
				(Array.isArray(o.tracking) && o.tracking.some((t: any) => this.matchesOrdersSearch(t.trackingnumber, term))) ||
				(Array.isArray(o.lines) && o.lines.some((l: any) => this.matchesOrdersSearch(l.stkcode, term))))
		);
	}

	filteredOpenOrdersCount(vendor: any): number {
		return this.filteredOpenOrders(vendor).length;
	}

	filteredOpenOrdersUnits(vendor: any): number {
		return this.filteredOpenOrders(vendor).reduce((sum: number, ord: any) => {
			const lines = Array.isArray(ord.lines) ? ord.lines : [];
			return sum + lines.reduce((acc: number, line: any) => acc + (Number(line.ordered) || 0), 0);
		}, 0);
	}

	// client-side pagination over the (possibly search-filtered) array
	displayedOpenOrders(vendor: any): any[] {
		const key = vendor.vendor_key;
		const all = this.filteredOpenOrders(vendor);
		const size = this.openOrdersPageSize[key] || 10;
		const idx = this.openOrdersPageIndex[key] || 0;
		return all.slice(idx * size, idx * size + size);
	}

	onOpenOrdersPage(vendor: any, event: PageEvent) {
		const key = vendor.vendor_key;
		this.openOrdersPageIndex[key] = event.pageIndex;
		this.openOrdersPageSize[key] = event.pageSize;
	}

	// commits the typed (uncommitted) search text into a chip — search box is shared across
	// both tabs: Open re-filters reactively (no fetch needed), Historical re-queries the
	// server immediately since it's paginated/capped. Both reset back to page 1.
	commitSearchChip(vendor: any) {
		const key = vendor.vendor_key;
		const term = (this.ordersSearchTerm[key] || '').trim();
		if (!term) { return; }
		const existing = this.searchChips[key] || [];
		if (!existing.includes(term)) {
			this.searchChips[key] = [...existing, term];
		}
		this.ordersSearchTerm[key] = '';
		this.onSearchChipsChange(vendor);
	}

	removeSearchChip(vendor: any, term: string) {
		const key = vendor.vendor_key;
		this.searchChips[key] = (this.searchChips[key] || []).filter((t) => t !== term);
		this.onSearchChipsChange(vendor);
	}

	private onSearchChipsChange(vendor: any) {
		const key = vendor.vendor_key;
		this.openOrdersPageIndex[key] = 0;
		this.clearOrderSelection(vendor);
		if (this.historicalView) {
			this.loadHistoricalOrders(vendor, 0);
		}
	}

	// switching into Historical while search chips are already set (added while on Open)
	// should apply them immediately rather than showing stale unfiltered results
	switchToHistorical(vendor: any) {
		this.historicalView = true;
		const key = vendor.vendor_key;
		if ((this.searchChips[key] || []).length || this.chartDateFilter[key]) {
			this.loadHistoricalOrders(vendor, 0);
		}
	}

	// server-paginated history of orders that have already cleared out of the open-orders
	// view (see getStickerHistoricalOrders() backend) — status name already reads
	// "Invoiced" (or whatever the closed state is), no separate invoice viewer needed.
	loadHistoricalOrders(vendor: any, pageIndex: number = 0) {
		if (!vendor.debtorno) { return; }
		const key = vendor.vendor_key;
		this.historicalOrdersPageIndex[key] = pageIndex;
		const pageSize = this.historicalOrdersPageSize[key] || 25;
		this.historicalOrdersLoading[key] = true;
		const period = this.orderPeriod[key];
		let dateFrom = period === 'custom' ? (this.customDateFrom[key] || '') : '';
		let dateTo = period === 'custom' ? (this.customDateTo[key] || '') : '';
		if (this.chartDateFilter[key]) {
			// single-day drilldown from a chart point click overrides the period range
			dateFrom = this.chartDateFilter[key];
			dateTo = this.chartDateFilter[key];
		}
		const search = this.searchChips[key] || [];
		this.ordersService.getStickerHistoricalOrders(vendor.debtorno, vendor.branchcode, vendor.connection_type, pageIndex + 1, pageSize, dateFrom, dateTo, search).subscribe((result: any) => {
			this.historicalOrdersLoading[key] = false;
			this.historicalOrders[key] = (result && Array.isArray(result.rows)) ? result.rows : [];
			this.historicalOrdersTotal[key] = (result && result.total) || 0;
			this.historicalOrdersTotalUnits[key] = (result && result.total_units) || 0;
		}, () => {
			this.historicalOrdersLoading[key] = false;
			this.historicalOrders[key] = [];
			this.historicalOrdersTotal[key] = 0;
			this.historicalOrdersTotalUnits[key] = 0;
		});
	}

	onHistoricalPage(vendor: any, event: PageEvent) {
		const key = vendor.vendor_key;
		this.historicalOrdersPageSize[key] = event.pageSize;
		this.loadHistoricalOrders(vendor, event.pageIndex);
	}

	// epoch ms; unparseable/missing dates sort first (treated as oldest) rather than crashing the sort
	private parseOrderDate(dt: string): number {
		if (!dt) { return 0; }
		const normalized = (dt.indexOf('T') === -1 && dt.indexOf(' ') !== -1) ? dt.replace(' ', 'T') : dt;
		const t = new Date(normalized).getTime();
		return isNaN(t) ? 0 : t;
	}

	formatOrderDateCreated(dt: string): string {
		if (!dt) { return ''; }
		if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dt)) { return this.formatLogTimestamp(dt); }
		const d = new Date(dt);
		if (isNaN(d.getTime())) { return dt; }
		return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
	}

	@ViewChild('details') detailsRef: ElementRef;
	displaydetails: any = false;
	openDocument(transaction: any, content: any, display: string) {
		switch (transaction.type) {
		case '11':
			this.globalsService.getCreditNote(transaction.id, display).subscribe((result: any) => {
				this.displaydetails = result;
				this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
			})
			break;
		case '10':
			this.globalsService.getInvoice(transaction.id, display).subscribe((result: any) => {
				this.displaydetails = result;
				this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
			})

			break;
		}
	}

	
	selectOrder(order: any, vendorKey: string) {
		this.orderfiles = false;
		this.filesloaded = false;

		const current = this.selectedOrder[vendorKey];
		if (current && current.orderno === order.orderno) {
			this.selectedOrder[vendorKey] = null;
			return;
		}
		this.selectedOrder[vendorKey] = order;
		if (!this.orderLinesCache[order.orderno]) {
			this.orderLinesLoading[order.orderno] = true;
			this.ordersService.getOrderLines(order.orderno).subscribe({
				next: (lines: any) => {
					this.orderLinesCache[order.orderno] = Array.isArray(lines) ? lines : [];
					this.orderLinesLoading[order.orderno] = false;
				},
				error: () => {
					// do NOT cache on error — leave orderLinesCache unset so the next click retries
					this.orderLinesLoading[order.orderno] = false;
				}
			});
		}

		if (this.filesloaded !== order.orderno) {
			this.loadingfiles = true;
			this.ordersService.getOrderFiles({ debtorno: order.debtorno, orderno: order.orderno }).subscribe({
				next: (res: any) => {
					this.orderfiles = Array.isArray(res) ? res : [];
					this.filesloaded = order.orderno;
					this.loadingfiles = false;
				},
				error: () => {
					// do NOT mark filesloaded on error — leave it so the next click retries
					this.loadingfiles = false;
				}
			});
		}

		if (!this.orderTotals[order.orderno]) {
			this.orderTotalsLoading[order.orderno] = true;
			this.ordersService.getOrderTotals(order.orderno).subscribe((result: any) => {
				this.orderTotals[order.orderno] = result;
				this.orderTotalsLoading[order.orderno] = false;
			}, () => {
				// do NOT cache on error — leave orderTotals unset so the next click retries
				this.orderTotalsLoading[order.orderno] = false;
			});
		}
	}

	filesloaded: any = false;
	loadingfiles: any = false;
	isOrderSelected(order: any, vendorKey: string): boolean {
		const sel = this.selectedOrder[vendorKey];
		return !!sel && sel.orderno === order.orderno;
	}

	selectedOrderLines(vendorKey: string): any[] {
		const sel = this.selectedOrder[vendorKey];
		return sel ? (this.orderLinesCache[sel.orderno] || []) : [];
	}

	// same toggle-and-lazy-load shape as selectOrder(), but for the historical-orders table —
	// deliberately does NOT touch orderfiles/filesloaded (shipping labels aren't relevant to
	// already-closed orders, and that state is shared/non-keyed — reusing it here would let
	// the two tables' selections stomp on each other).
	selectHistoricalOrder(order: any, vendorKey: string) {
		const current = this.selectedHistoricalOrder[vendorKey];
		if (current && current.orderno === order.orderno) {
			this.selectedHistoricalOrder[vendorKey] = null;
			return;
		}
		this.selectedHistoricalOrder[vendorKey] = order;

		if (!this.orderLinesCache[order.orderno]) {
			this.orderLinesLoading[order.orderno] = true;
			this.ordersService.getOrderLines(order.orderno).subscribe({
				next: (lines: any) => {
					this.orderLinesCache[order.orderno] = Array.isArray(lines) ? lines : [];
					this.orderLinesLoading[order.orderno] = false;
				},
				error: () => {
					this.orderLinesLoading[order.orderno] = false;
				}
			});
		}

		if (!this.orderTotals[order.orderno]) {
			this.orderTotalsLoading[order.orderno] = true;
			this.ordersService.getOrderTotals(order.orderno).subscribe((result: any) => {
				this.orderTotals[order.orderno] = result;
				this.orderTotalsLoading[order.orderno] = false;
			}, () => {
				this.orderTotalsLoading[order.orderno] = false;
			});
		}
	}

	isHistoricalOrderSelected(order: any, vendorKey: string): boolean {
		const sel = this.selectedHistoricalOrder[vendorKey];
		return !!sel && sel.orderno === order.orderno;
	}

	selectedHistoricalOrderLines(vendorKey: string): any[] {
		const sel = this.selectedHistoricalOrder[vendorKey];
		return sel ? (this.orderLinesCache[sel.orderno] || []) : [];
	}

	// non-empty ship-to lines: order-level deliverto/deladd1-6 (falls back to nothing if the order has none)
	shipToLines(order: any): string[] {
		if (!order) { return []; }
		return [order.deliverto, order.deladd1, order.deladd2, order.deladd3, order.deladd4, order.deladd5, order.deladd6]
			.map((l: any) => (l == null ? '' : String(l)).trim())
			.filter((l: string) => !!l);
	}

	goToOrder(orderno: any, event: Event) {
		event.stopPropagation();
		this.ordersService.loadSalesOrder(orderno).subscribe((result: any) => {
			if (result && result.header) {
				this.router.navigate(['./orders/entry/' + result.header.debtorno + '/' + result.header.branchcode]);
			}
		});
	}

	loadOpenPurchaseOrders(vendor: any) {
		if (!vendor.debtorno) { return; }
		const key = vendor.vendor_key;
		this.openPurchaseOrdersLoading[key] = true;
		this.ordersService.getOpenPurchaseOrders(vendor.debtorno).subscribe((results: any) => {
			this.openPurchaseOrdersLoading[key] = false;
			this.openPurchaseOrders[key] = Array.isArray(results) ? results : [];
		}, () => {
			this.openPurchaseOrdersLoading[key] = false;
			this.openPurchaseOrders[key] = [];
		});
	}

	openPOsForOrder(vendorKey: string, orderno: any): any[] {
		return (this.openPurchaseOrders[vendorKey] || []).filter((po: any) => po.orderno == orderno);
	}

	poForOrderLine(vendorKey: string, orderno: any, orderlineno: any): any {
		return (this.openPurchaseOrders[vendorKey] || []).find((po: any) =>
			po.orderno == orderno && po.orderlineno == orderlineno);
	}

	hasAnyPoForItems(flyout: { vendorKey: string; orderno: any; items: any[] }): boolean {
		return (flyout.items || []).some((item: any) => !!this.poForOrderLine(flyout.vendorKey, flyout.orderno, item.orderlineno));
	}

	poRowsTotal(flyout: { vendorKey: string; orderno: any; items: any[] }): number {
		return (flyout.items || []).reduce((sum, item) => {
			const po = this.poForOrderLine(flyout.vendorKey, flyout.orderno, item.orderlineno);
			return sum + (po ? (Number(po.quantityord) || 0) * (Number(po.unitprice) || 0) : 0);
		}, 0);
	}

	debtorSearch(term: string, vendor: any) {
		if (this.debtorSearchSub) { this.debtorSearchSub.unsubscribe(); }
		if (!term || term.length < 1) { this.debtorSearchResults[vendor.vendor_key] = []; return; }
		this.debtorSearching[vendor.vendor_key] = true;
		this.debtorSearchSub = this.customerService.getCustomerSearch({
			source: 'stickerfeed',
			keywords: term
		}).subscribe((results: any) => {
			this.debtorSearching[vendor.vendor_key] = false;
			this.debtorSearchResults[vendor.vendor_key] = Array.isArray(results) ? results : [];
		}, () => { this.debtorSearching[vendor.vendor_key] = false; });
	}

	displayDebtorFn(c: any): string {
		return c ? `${c.debtorno} — ${c.name || ''}` : '';
	}

	selectDebtor(vendor: any, customer: any) {
		vendor.debtorno = customer.debtorno;
		vendor.debtor_name = customer.name || '';
		vendor.branchcode = '';
		vendor.branch_name = '';
		this.debtorSearchTerm[vendor.vendor_key] = this.displayDebtorFn(customer);
		this.branchOptions[vendor.vendor_key] = [];
		this.loadBranches(vendor);
		this.loadOpenOrders(vendor);
		this.loadOrderCounts(vendor);
		this.loadOpenPurchaseOrders(vendor);
	}

	loadBranches(vendor: any) {
		if (!vendor.debtorno) { return; }
		this.customerService.getBranches(vendor.debtorno).subscribe((branches: any) => {
			this.branchOptions[vendor.vendor_key] = Array.isArray(branches) ? branches : [];
		});
	}

	onBranchSelected(vendor: any, branchcode: string) {
		const match = (this.branchOptions[vendor.vendor_key] || []).find((b: any) => b.branchcode === branchcode);
		vendor.branch_name = match ? match.brname : '';
	}

	titlePillVars(v: any): Record<string, string> {
		return buildDashboardThemeVars('title-pill', v.status === 'red' ? 'danger' : 'dark');
	}

	vendorInitial(v: any): string {
		return v.vendor_label ? v.vendor_label.trim().charAt(0).toUpperCase() : '?';
	}

	private computeStatus(v: any): string {
		if (v.connection_type === 'api') {
			const hasCredentials = v.auth_type === 'static_bearer'
				? !!v.access_token_set
				: !!(v.client_id && v.client_secret_set);
			return hasCredentials ? 'green' : 'red';
		}

		const creds = [v.password_set, v.username, v.serverhost].filter(Boolean).length;
		if (creds === 3) return 'green';
		if (creds === 0) return 'red';
		return 'yellow';
	}

	generateCredentials(vendor: any) {
		vendor.generatingCredentials = true;
		vendor.revealed = null;
		this.globals.generateFeedCredentials({ id: vendor.id, auth_type: vendor.auth_type }).subscribe((result: any) => {
			vendor.generatingCredentials = false;
			if (!result || result.success === false) {
				this.saveError[vendor.vendor_key] = (result && result.error) || 'Failed to generate credentials';
				return;
			}

			if (vendor.auth_type === 'static_bearer') {
				vendor.access_token_set = true;
				vendor.revealed = { bearer_token: result.bearer_token };
			} else {
				vendor.client_id = result.client_id;
				vendor.client_secret_set = true;
				vendor.revealed = { client_id: result.client_id, client_secret: result.client_secret };
			}

			vendor.status = this.computeStatus(vendor);
		}, (err) => {
			vendor.generatingCredentials = false;
			this.saveError[vendor.vendor_key] = 'Failed to generate credentials (' + (err?.status || 'network error') + ')';
		});
	}

	dismissRevealedCredentials(vendor: any) {
		vendor.revealed = null;
	}

	get stickerFeedTokenEndpoint(): string {
		return this.globals.getStickerFeedTokenEndpoint();
	}

	get stickerFeedFeedEndpoint(): string {
		return this.globals.getStickerFeedFeedEndpoint();
	}

	addBrand(vendor: any) {
		const brand = (this.newBrand[vendor.vendor_key] || '').trim().toUpperCase();
		if (!brand) return;
		if (!vendor.excluded_brands.includes(brand)) {
			vendor.excluded_brands = [...vendor.excluded_brands, brand];
		}
		this.newBrand[vendor.vendor_key] = '';
	}

	removeBrand(vendor: any, brand: string) {
		vendor.excluded_brands = vendor.excluded_brands.filter((b: string) => b !== brand);
	}

	filterBrands(vendor: any): any[] {
		if (!this.brands) return [];
		const term = (vendor.brandFilter || '').trim().toLowerCase();
		if (!term) return this.brands;
		return this.brands.filter((b: any) =>
			(b.name || '').toLowerCase().includes(term) ||
			(b.mfg_code || '').toString().toLowerCase().includes(term)
		);
	}

	toggleBrandEditor(vendor: any) {
		vendor.showBrandEditor = !vendor.showBrandEditor;
	}

	getBrandMfgCode(brandName: string): string {
		if (!this.brands) return '';
		const match = this.brands.find((b: any) => b.name === brandName);
		return match ? match.mfg_code : '';
	}

	toggleBrand(vendor: any, brand: string) {
		if (vendor.excluded_brands.includes(brand)) {
			this.removeBrand(vendor, brand);
		} else {
			vendor.excluded_brands = [...vendor.excluded_brands, brand];
		}
	}

	setAllBrands(vendor: any, excluded: boolean) {
		const visible = this.filterBrands(vendor).map((b: any) => b.name);
		if (excluded) {
			vendor.excluded_brands = [...new Set([...vendor.excluded_brands, ...visible])];
		} else {
			vendor.excluded_brands = vendor.excluded_brands.filter((b: string) => !visible.includes(b));
		}
	}

	toggleEndpoint(vendor: any, function_id: any) {
		if (vendor.allowed_endpoints.includes(function_id)) {
			vendor.allowed_endpoints = vendor.allowed_endpoints.filter((id: any) => id !== function_id);
		} else {
			vendor.allowed_endpoints = [...vendor.allowed_endpoints, function_id];
		}
	}

	onShipviaChange(vendor: any) {
		const freight: { [key: string]: any } = {};
		const requiresLabel: { [key: string]: boolean } = {};
		vendor.allowed_shipvia.forEach((id: any) => {
			freight[id] = vendor.shipvia_freight[id] != null ? vendor.shipvia_freight[id] : '';
			requiresLabel[id] = !!vendor.shipvia_requires_label[id];
		});
		vendor.shipvia_freight = freight;
		vendor.shipvia_requires_label = requiresLabel;
	}

	getShipperName(id: any): string {
		const match = this.shipviaOptions.find((s: any) => this.compareShipvia(s.shipper_id, id));
		return match ? match.shippername : '';
	}

	getTrackingColor(shipper: string | null | undefined): string {
		return this.carrierTracking.getTrackingColor(shipper);
	}

	compareShipvia(a: any, b: any): boolean {
		return a != null && b != null && +a === +b;
	}

	save(vendor: any) {
		const sorted = [...new Set(vendor.excluded_brands)].sort((a: string, b: string)=>{
			if(a>b){return 1}
			if(a == b){return 0}
			if(a < b){return -1}
		})
		vendor.excluded_brands = sorted;

		const payload: any = {
			adding: vendor.adding,
			vendor_key: vendor.vendor_key,
			vendor_label: vendor.vendor_label,
			debtorno: vendor.debtorno || '',
			branchcode: vendor.branchcode || '',
			excluded_brands: sorted,
			excluded_stockids: vendor.excluded_stockids.map((i: any) => i.stockid),
			shipvia: vendor.allowed_shipvia.map((id: any) => ({
				shipper_id: id,
				freight_price: vendor.shipvia_freight[id] || 0,
				requires_label: !!vendor.shipvia_requires_label[id]
			})),
			username: vendor.username || '',
			serverhost: vendor.serverhost || '',
			path: vendor.path || '',
			protocol: vendor.protocol || '',
			protocol_type: vendor.protocol_type || '',
			port: vendor.port || '',
			filename: vendor.filename || '',
			emailcopy: vendor.emailcopy ? 1 : 0,
			blankstartrow: vendor.blankstartrow ? 1 : 0,
			connection_type: vendor.connection_type || 'ftp',
			auth_type: vendor.auth_type || '',
			api_endpoints_allowed: vendor.allowed_endpoints || []
		};

		if (vendor.password) {
			payload.password = vendor.password;
		}

		this.saving[vendor.vendor_key] = true;
		this.saved[vendor.vendor_key] = false;
		this.saveError[vendor.vendor_key] = '';
		this.globals.saveFeedExclusion(payload).subscribe((result: any) => {
			delete(vendor.adding)
			this.saving[vendor.vendor_key] = false;
			if (!result || result.success === false) {
				this.saveError[vendor.vendor_key] = (result && result.error) || 'Save failed';
				console.error('saveFeedExclusion failed', result);
				return;
			}
			this.saved[vendor.vendor_key] = true;
			if (vendor.password) {
				vendor.password_set = true;
			}
			vendor.password = '';
			vendor.status = this.computeStatus(vendor);

		}, (err) => {
			this.saving[vendor.vendor_key] = false;
			this.saveError[vendor.vendor_key] = 'Save failed (' + (err?.status || 'network error') + ')';
			console.error('saveFeedExclusion request error', err);
		});
	}


	removeclient(client){}

	keyCheck(e){
		const to_check = e.target.value;
		
		if(this.keys_used.includes(to_check.toLowerCase())){
			this.key_in_use = true;
		}else{
			this.key_in_use = false;
		}
	}

	labelCheck(e){
		const to_check = e.target.value;
		if(this.labels_used.includes(to_check.toLowerCase())){
			this.label_in_use = true;
		}else{
			this.label_in_use = false;
		}
	}


	run(client: any = false){
		let data: any = false
		
		if(client){
			client.generating = true;
			data = {clients: [client.id]};
		}
		this.globals.runstickerfeed(data).subscribe((res)=>{
			
		})
	}

	addclient(){
		if(this.anyExpanded){
			this.closeExpanded()
		}

		//open dummy client
		this.clients.forEach(c => {
			if(c.id == 'new'){
				c.adding = true;
				c.viewing = 'settings';
				c.focused = true;
				c.closing = false;
				c.vendor_key = '';
				c.vendor_label = '';
				c.debtorno = '';
				c.branchcode = '';
				c.debtor_name = '';
				c.branch_name = '';
				c.allowed_shipvia = [];
				c.shipvia_freight = {};
				c.shipvia_requires_label = {};
				c.allowed_endpoints = [];
				this.debtorSearchTerm[c.vendor_key] = '';
				this.branchOptions[c.vendor_key] = [];
			}
		});
	}

	toggleItemPicker(vendor: any){
		vendor.showItemPicker = !vendor.showItemPicker;
	}

	updateBlockedSkus(vendor: any, items: any[]){
		this.mergeStockIds(vendor, items);
		vendor.showItemPicker = false;
	}

	removeStockId(vendor: any, stockid: string) {
		vendor.excluded_stockids = vendor.excluded_stockids.filter((i: any) => i.stockid !== stockid);
	}

	copyfrom(client){
		client.copying = true;
		this.copying = {
			'brands' : client.excluded_brands,
			'skus' : client.excluded_stockids,
			'from' : client
		}
	}

	copyto(client){
		client.excluded_brands = this.copying['brands'];
		client.excluded_stockids = this.copying['skus'];
		this.save(client);
	}

	stopcopy(client){
		if(client.copying && this.copying){
			client.copying = false;
			this.copying = false;
		}
	}

	private mergeStockIds(vendor: any, items: any[]) {
		const merged = [...vendor.excluded_stockids];
		items.forEach((item: any) => {
			const stockid = (item.stockid || '').toString().trim();
			if (stockid && !merged.some((m: any) => m.stockid === stockid)) {
				merged.push({ stockid, description: item.description || '' });
			}
		});
		vendor.excluded_stockids = merged;
	}

	onStockIdFileSelect(event: Event, vendor: any) {
		const input = event.target as HTMLInputElement;
		const file = input.files?.[0];
		input.value = '';
		if (!file) return;

		this.stockidUploadError[vendor.vendor_key] = '';
		const ext = file.name.split('.').pop()?.toLowerCase();
		if (ext !== 'xlsx' && ext !== 'xls' && ext !== 'csv') {
			this.stockidUploadError[vendor.vendor_key] = 'Unsupported file type. Use .xlsx, .xls, or .csv';
			return;
		}

		const reader = new FileReader();
		reader.onload = (e) => {
			try {
				const data = new Uint8Array(e.target!.result as ArrayBuffer);
				const wb = XLSX.read(data, { type: 'array' });
				const ws = wb.Sheets[wb.SheetNames[0]];
				const rows = XLSX.utils.sheet_to_json<Record<string, any>>(ws, { defval: '' });

				if (!rows.length) {
					this.stockidUploadError[vendor.vendor_key] = 'File is empty';
					return;
				}

				const headerKey = Object.keys(rows[0]).find((h) => h.replace(/[\s_]+/g, '').toLowerCase() === 'stockid');
				if (!headerKey) {
					this.stockidUploadError[vendor.vendor_key] = 'No "stockid" column found in file';
					return;
				}

				const items = rows
					.map((r) => ({ stockid: (r[headerKey] || '').toString().trim(), description: '' }))
					.filter((r) => r.stockid);

				this.mergeStockIds(vendor, items);
			} catch {
				this.stockidUploadError[vendor.vendor_key] = 'Failed to parse file';
			}
		};
		reader.readAsArrayBuffer(file);
	}

	deactiveall(){
		const to_deactive = [];
		this.clients.forEach((c)=>{
			c.active = false;
			if(c.id !== 'new' && !c.adding){
				to_deactive.push(c.id);
			}
		});
	}


	reprint(type, data){
		let download;
		let link;
		switch(type){
			case 'pick':
				download = this.pickinglink + data.orderno + '&isPOS=false';
				link = document.createElement('a');
				link.href = download;
				link.download = data.orderno + '_pick.pdf';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			break;
			case 'label':
			break;
			case 'invoice':
				download = this.invoicelink + data.orderno + "&isPOS=false";
				link = document.createElement('a');
				link.href = download;
				link.download = data.orderno + '_invoice.pdf';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			break;
			default:
			break;
		}
	}









	private blobToBase64(blob: Blob): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onloadend = () => {
				const dataUrl = reader.result as string;
				if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.includes(',')) {
					reject(new Error('Invalid pick document'));
					return;
				}
				resolve(dataUrl.split(',')[1]);
			};
			reader.onerror = () => reject(reader.error ?? new Error('read failed'));
			reader.readAsDataURL(blob);
		});
	}

	async urlToBlob(url: string) {
		const response = await fetch(url);
		return await response.blob();
	  }

	isVideo(file: any): boolean {
		if (!file || !file.link || typeof file.link !== 'string') {
			return false; // Ensure file.link exists and is a string
		}

		// Define supported video extensions
		const videoExtensions = [
			'mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'webm', 'ogg', 'm4v'
		];

		// Extract filename without query parameters
		const filename = file.link.split('?')[0];

		// Create a case-insensitive regex pattern for matching video extensions
		const videoRegex = new RegExp(`\\.(${videoExtensions.join('|')})$`, 'i');

		return videoRegex.test(filename);
	}

	isImage(file: any): boolean {

		if (!file || !file.link || typeof file.link !== 'string') {
			return false;
		}
		const imageExtensions = [
			'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'tif',
			'heic', 'heif', 'ico', 'svg', 'raw', 'cr2', 'nef',
			'orf', 'sr2', 'psd', 'ai', 'eps', 'avif'
		];

		// Extract filename without query parameters
		const filename = file.link.split('?')[0]; // Remove URL params
		// Create a case-insensitive regex pattern for matching image extensions
		const imageRegex = new RegExp(`\\.(${imageExtensions.join('|')})$`, 'i');

		return imageRegex.test(filename);
	}

	viewingdoc: any = false;
	@ViewChild('documentModal') documentModalRef: ElementRef;
	openFile(doc: any): void {
		this.viewingdoc = doc;
		this.modalService.open(this.documentModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {
		}, (reason) => {
			
		});
	}


	printLabels(orderfiles) {
		//with cdn being https having issues fetching from http
		if(!orderfiles.length || !Array.isArray(orderfiles)){return}
		const prints = [];
		orderfiles.forEach(file => {
			this.urlToBlob(file.link).then(
				(fileblob) => {
					this.blobToBase64(fileblob as Blob).then(
						(b64) => {
							prints.push(b64)
						});
				})
		});

		prints.forEach(job => {
			this.sendPrint(job);
		});
	}

	sendPrint(base64: any, type = 'LABEL') {
		this.omsService.setNewOrder();
		this.globalSearchService.user.subscribe(user => {
			const printers = this.usersService.getDevicesByType(user.user.userid, type);
			const data = { pdf: base64, user: user, devices: printers }
			if (printers && printers.length) {
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			}
		});
	}

}
